<template>
  <div :class="$style.root">
    <SvgIcon :class="$style.icon" :svg="require('!svg-inline-loader?classPrefix!@mdi/svg/svg/filter.svg')" :size="40" />
    <ul :class="$style.categoryList">
      <li v-for="category in modifiedCategories" :key="category.value">
        <Button
          @click="handleCategory(category)"
          :class="computedCategoryClass(category)"
          :active="$props.category == category.value"
        >
          {{ category.label }}
        </Button>
      </li>
    </ul>
    <Coin :class="$style.balance" :n="balance" appear />
  </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon'
import Button from '@/components/Button'
import Coin from '@/components/Coin'
import { mapGetters } from 'vuex'
import { PURCHASED_CATEGORY } from '@/views/Shop'

export default {
  components: {
    SvgIcon,
    Button,
    Coin,
  },
  props: {
    category: {
      type: String,
    },
  },
  computed: {
    modifiedCategories () {
      return [
        {value: null, label: '全部'}, 
        ...this.categories,
        {value: PURCHASED_CATEGORY, label: '已購買'},
      ]
    },
    ...mapGetters('shop', {
      categories: 'categories',
    }),
    ...mapGetters('auth', {
      balance: 'balance',
    }),
  },
  methods: {
    handleCategory ({ value }) {
      this.$emit('update:category', value)
    },
    computedCategoryClass ({ value }) {
      return [this.$style.category, {
        [this.$style.category_active]: this.category == value
      }]
    },
  },
}
</script>

<style lang="scss" module>
.root {
  @apply flex;
  @apply items-center;
}

.icon {
  color: #653000;
}

.categoryList {
  @apply list-none;
  @apply p-0;
  @apply m-0;
  @apply flex;
  @apply flex-wrap;
  @apply flex-grow;

  > li {
    @apply mx-2;
  }
}

.category {
  font-size: 1.2rem;
  @apply cursor-pointer;
}

.balance {
  //
}
</style>
